import DecisionModalContainer from "features/content-overlay/decision/DecisionModalContainer"
import { ModalContainerComponent } from "./types"

/**
 * a simple wrapper to keep things consistant with the others, but modular enough to handle more distinct decision logic
 */
export const DecisionModal = () => {
    return <DecisionModalContainer />
}

export default DecisionModal as ModalContainerComponent
